<template>
    <div class="font-weight-bold">
      <b-modal id="price_modal" title="支払金額情報" size="lg" ok-only>
        <b>支払金額情報</b>
        <p>サービス価格のポリシーです。サーバー台数と利用状況により異なります。条件を変更したい場合は、サービス条件変更申請により、より高度なサービスを利用することができます。</p>
        <p>お支払い金額についてご不明な点がございましたら、3営業日以内に審査させていただきますので、メール pay@f1security.co.kr までご連絡ください。</p>
        <b style="font-style: italic;">UWSS 価格</b>
        <table style="height: 405px; width: 770px; border:1px solid gray;">
          <tbody style="border:1px solid gray;">
            <tr style="height: 25px;" class="a">
              <td class="a" style="width: 399px; height: 25px;" colspan="2"></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id"><b>{{service.service_name}}</b></td>
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 399px; height: 25px;" colspan="2"><b>価格（月額課金）</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id"><b>$ {{service.base_price}}</b></td>
              <!-- <td class="a" style="width: 119px; height: 25px;">$59</td>
              <td class="a" style="width: 119px; height: 25px;">$159</td>
              <td class="a" style="width: 106px; height: 25px;">$599</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 75px;" rowspan="3"><b>サービス対象</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>Webサーバー数</b></td>
              <td class="a" style="width: 119px; height: 50px;" v-for="service in (services || [])" v-bind:key="service.id" rowspan="2">1</td>
              <!-- <td class="a" style="width: 119px; height: 50px;" rowspan="2">1</td>
              <td class="a" style="width: 106px; height: 50px;" rowspan="2">1</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>* 物理的または論理的サーバー</b></td>
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>Webドメイン数</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">
                {{
                service.target_domain > 0 ? (service.target_domain == 1 ? service.target_domain : `1 ~ ${service.target_domain}`) : `${service.target_domain * -1} +`
                }}
              </td>
              <!-- <td class="a" style="width: 119px; height: 25px;">1 ~ 4</td>
              <td class="a" style="width: 106px; height: 25px;">5 +</td> -->
            </tr>
            <!-- 방화벽 -->
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 50px;" rowspan="2"><b>Web Hacking Protection<br>(server)</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>HTTPS/SSL via WAF</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.waf > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>Web Application Firewall</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.waf > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <!-- 웹쉘파인더 -->
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 50px;" rowspan="2"><b>WebShell Protection <br>(server)</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>WebShellの検出・遮断</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.wsfinder > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>WebShell Analysis Support</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.wsfinder_analysis > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 50px;" rowspan="2"><b>Web Malware Protection<br>(ドメイン)</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>Webマルウェアの配布検知</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">
                {{service.wmds_site > 0 ? `O` : 'N/A'}}
                <br>
                <small>{{service.wmds_site > 0 ? `(MAX ${service.wmds_page || 0} pages)` : ''}}</small>
              </td>
              <!-- <td class="a" style="width: 119px; height: 25px;">O<br>(Max 50 pages)</td>
              <td class="a" style="width: 119px; height: 25px;">O<br>(Max 500 pages)</td>
              <td class="a" style="width: 106px; height: 25px;">O<br>(Max 5,000 pages)</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>Web マルウェア解析サポート</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.wmds_analysis > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 100px; height: 26px;"><b>Web 偽造防止</b></td>
              <td class="a" style="width: 200px; height: 26px;"><b>Web 偽造の検出</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.integrity > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 100px; height: 130px;" rowspan="5"><b>テクニカルサポート</b></td>
              <td class="a" style="width: 200px; height: 26px;"><b>専用サポートチーム</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.technical_support > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>エージェント導入サポート</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.install_support > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>セキュリティポリシー設定サポート</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.policy_support > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>メールでの応答</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">24x7x365 <br>{{`within ${service.email_support} hours`}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">24時間365日、8時間以内</td>
              <td class="a" style="width: 119px; height: 26px;">24時間365日、4時間以内</td>
              <td class="a" style="width: 106px; height: 26px;">24時間365日、2時間以内</td> -->
            </tr>
              <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>電話による応答</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.phone_support > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
          </tbody>
        </table>
      </b-modal>
    </div>
</template>
<style>
.a {
  border: 1px solid gray;
  text-align: center;
  font-style: italic;
}
.k {
  /* width : 300px; */
  height: 200px;
}
.g {
  /* width: 33px; */
  height: 100px;
}
.s {
  width: 1075px;
  height: 300px;
}
</style>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>